import {
	SnackbarContainer,
	SnackbarContent,
	SnackbarText,
	StyledCancelIcon,
	StyledCheckCircle
} from "./SnackBar.styles";
import CircularProgress from "@mui/material/CircularProgress";
import Snackbar from "@mui/material/Snackbar";

interface Props {
	open: boolean;
	isLoading: boolean;
	loadingText: string;
	errorText: string;
	successText: string;
	isError?: boolean;
}

const SnackbarComponent = ({ open, isLoading, loadingText, errorText, successText, isError }: Props) => {
	return (
		<Snackbar
			open={open}
			anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
		>
			<SnackbarContainer>
				{isLoading ? (
					<SnackbarContent>
						<CircularProgress size="16px" />
						<SnackbarText>{loadingText}</SnackbarText>
					</SnackbarContent>
				) : (
					<SnackbarContent>
						{!isError ? (
							<>
								<StyledCheckCircle />
								<SnackbarText>{successText}</SnackbarText>
							</>
						) : (
							<>
								<StyledCancelIcon />
								<SnackbarText>{errorText}</SnackbarText>
							</>
						)}
					</SnackbarContent>
				)}
			</SnackbarContainer>
		</Snackbar>
	);
};

export default SnackbarComponent;
